<template>
  <div class="setting-container">
    <div class="setting-title">阅读设置</div>
    <div class="setting-item">
      <div class="setting-label">字号</div>
      <el-slider
        v-model="fontSizeVal"
        :step="20"
        :min="10"
        :max="130"
        :show-tooltip="false"
        @input="handleFontSizeChange"
        show-stops
      >
      </el-slider>
      <div class="demonstration">
        <span class="little-font">小</span><span class="big-font">大</span>
      </div>
    </div>
    <div class="setting-item">
      <div class="setting-label">纸色</div>
      <ul class="set-bg-color">
        <li
          v-for="i in 7"
          :key="i"
          :class="['bg' + i, activeBg == i ? 'active' : '']"
          @click="changeBg($event, i)"
        ></li>
        <!-- <li class="bg1" @click="changeBg"></li>
        <li class="bg2 active" @click="changeBg"></li>
        <li class="bg3" @click="changeBg"></li>
        <li class="bg4" @click="changeBg"></li>
        <li class="bg5" @click="changeBg"></li>
        <li class="bg6" @click="changeBg"></li> -->
      </ul>
    </div>
  </div>
</template>

<script>
export default {
    name: "setting",
    data() {
      return {
        fontSizeVal: 50,
        activeBg: 3
      }
    },
    methods: {
      
      // 设置字体大小
      handleFontSizeChange(value) {
        this.$emit('fontSizeChange', value)
      },
      changeBg(event, index) {
        this.activeBg = index
        let element = event.target
        let style = element.currentStyle || window.getComputedStyle(element);
        let backgroundColor = style.backgroundColor;
        this.$emit('backgroundColorChange', backgroundColor)
      },
    }
  }
</script>

<style lang="scss" scoped>
.setting-container{
  .setting-title{
    font-size: 18px;
    line-height: 28px;
    height: 60px;
    font-weight: bold;
    padding: 10px;
  }

  .setting-item{
    padding: 0 10px;

    .setting-label{
      font-size: 16px;
      padding: 10px 0;
      margin-top: 30px;
    }

    &:nth-child(2){
      .setting-label{
        margin-top: 0;
      }
    }
    
    .demonstration {
      width: 100%;
      margin-top: 12px;
      display: flex;
      justify-content: space-between;
      .little-font {
        font-size: 16px;
        font-weight: bold;
      }
      .big-font {
        font-size: 22px;
        font-weight: bold;
      }
    }
    
    .set-bg-color {
      width: 90%;
      margin: 30px auto;
      display: flex;
      justify-content: space-between;
      li {
        width: 40px;
        height: 40px;
        border-radius: 20px;
        border: 3px solid #c1c1c1;
        transform: scale(1);
        transition: transform 0.2s;
      }
      li.bg1 {
        background: #fff;
      }
      li.bg2 {
        background: #d5edf4;
      }
      li.bg3 {
        background: #DBECFA;
      }
      li.bg4 {
        background: #ebfbf8;
      }
      li.bg5 {
        background: #fafbeb;
      }
      li.bg6 {
        background: #f8ebe5;
      }
      li.bg7 {
        background: #f4edf6;
      }
      li:hover {
        transform: scale(1.2);
      }
      li.active {
        transform: scale(1.1);
        border: 5px solid #0FC29A;
      }
    }
  }
}
/deep/.el-slider{
  .el-slider__runway{
    background: #DDDDDD;

    .el-slider__bar{
      background: #0FC29A;
    }

    .el-slider__button{
      border: solid 2px #0FC29A;
    }
  }
}
</style>